// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor-margin {
  margin-bottom: 30px;
}

h1 {
  font-size: 18px;
  font-weight: 900;
  margin: 10px 0;
  align-self: center;
  line-height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/employees/employ-history/employ-history.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AACJ","sourcesContent":[".editor-margin{\n    margin-bottom:30px;\n}\n\nh1 {\n    font-size: 18px;\n    font-weight: 900;\n    margin: 10px 0;\n    align-self: center;\n    line-height: 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
